import NoLabel from "./no-label.svg";

export const RedIcons = {
  NoLabel,
};
